/**
 * 예약 시간 포맷 유틸.
 * 오늘/내일 요일 기준 reserveTime 객체에서 "start ~ end" 문자열을 반환한다.
 */

export type ReserveTimeDay = {
  start?: string;
  end?: string;
};

export type ReserveTimeMap = Record<string, ReserveTimeDay | undefined>;

/** 월요일=0, 일요일=6 인 요일 인덱스 (문자열). */
export function getDayOfWeekIndex(date: Date): string {
  return ((date.getDay() + 6) % 7).toString();
}

/** 내일 요일 인덱스. */
export function getTomorrowDayOfWeekIndex(): string {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return getDayOfWeekIndex(tomorrow);
}

export function getReserveTime(reserveTime: ReserveTimeMap | null | undefined): string {
  const dayOfWeek = getDayOfWeekIndex(new Date());
  const day = reserveTime?.[dayOfWeek];
  return day?.start && day?.end ? `${day.start} ~ ${day.end}` : "";
}

export function getReserveTimeForTomorrow(
  reserveTime: ReserveTimeMap | null | undefined
): string {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDayOfWeek = getDayOfWeekIndex(tomorrow);
  const day = reserveTime?.[tomorrowDayOfWeek];
  return day?.start && day?.end ? `${day.start} ~ ${day.end}` : "";
}
